import React, { Component } from 'react';
import moment from 'moment';
export default class Footer extends Component {
    render() {
        return (
            <footer className=" text-center Copyright-2020-Universal-Health-Fellowship-All" style={{marginTop:'-15px'}}>
                Copyright © {moment().format("YYYY")} netWell. All rights reserved. | Powered by netWell
            </footer>
        )
    }
}

